import { ButtonLink, ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../../Resources/Translations';
import { OrderResultStatus } from '../../Services/Models/OrderResultStatus.csharp';

interface OrderListEmptyStateProps {
    status?: OrderResultStatus;
}

export const OrderListEmptyState = ({ status }: OrderListEmptyStateProps) => {
    switch (status) {
        case OrderResultStatus.Ok:
            return (
                <div className="OrderListEmptyState">
                    <img
                        src="/dist/assets/images/orderListEmpty.svg"
                        className="OrderListEmptyState__Image"
                        loading="lazy"
                        alt={getTranslation(keys['userProfile.orderHistory.emptyTitle'])}
                    />
                    <span className="OrderListEmptyState__Title">{getTranslation(keys['userProfile.orderHistory.emptyTitle'])}</span>
                    <span className="OrderListEmptyState__Subtitle">
                        {getTranslation(keys['userProfile.orderHistory.emptySubtitle1'])} <br />
                        {getTranslation(keys['userProfile.orderHistory.emptySubtitle2'])}
                    </span>
                    <ButtonLink size={ButtonSize.Medium} href="/search" className="OrderListEmptyState__Button">
                        {getTranslation(keys['userProfile.orderHistory.emptyButton'])}
                    </ButtonLink>
                </div>
            );
        default:
            return (
                <div className="OrderListEmptyState">
                    <img
                        src="/dist/assets/images/orderListNoConnection.svg"
                        className="OrderListEmptyState__Image"
                        loading="lazy"
                        alt={getTranslation(keys['userProfile.orderHistory.noConnectionTitle'])}
                    />
                    <span className="OrderListEmptyState__Title">{getTranslation(keys['userProfile.orderHistory.noConnectionTitle'])}</span>
                    <span className="OrderListEmptyState__Subtitle">
                        {getTranslation(keys['userProfile.orderHistory.noConnectionSubtitle1'])} <br />
                        {getTranslation(keys['userProfile.orderHistory.noConnectionSubtitle2'])}
                    </span>
                </div>
            );
    }
};
